/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import loader from "./loader";

const TWOTAP_HREF = "https://checkout.twotap.com/js/publisher_cart.js";

const loadTT = loader(() => {
    window.TTPublicToken = "8765e775f43306736a019aaaa93ec9";

    const tt = document.createElement('script');
    const s = document.getElementsByTagName('script')[0];
    tt.type = 'text/javascript';
    tt.async = true;
    tt.src = TWOTAP_HREF;
    s.parentNode.insertBefore(tt, s);
});

const load = loader(() => {
    if (!window.jQuery) {
        const jq = document.createElement('script');
        const s = document.getElementsByTagName('script')[0];
        jq.type = 'text/javascript';
        jq.async = true;
        jq.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js';
        jq.onload = loadTT;
        s.parentNode.insertBefore(jq, s);

        const preloadLink = document.createElement('link');
        preloadLink.href = TWOTAP_HREF;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
    } else {
        loadTT();
    }
});

let tt_product = undefined;
let tt_promises = [];
let tt_loaded = false;

function launchCheckout(product) {
    tt_product = product;
}

window.TTLoadedCallback = function() {
    tt_loaded = true;
    tt_promises.forEach(resolve => resolve());
    if (tt_product) {
        window.TTStartCheckout(tt_product)
    }
    launchCheckout = window.TTStartCheckout;
}

export default function(product) {
    return new Promise((resolve, reject) => {
        load();
        if (product) {
            launchCheckout([product])
        }
        if (!tt_loaded) {
            tt_promises.push(resolve);
        } else {
            resolve();
        }
    });
};

